import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import classes from './buttons.scss';
export const Buttons = ({
  onNextButton,
  onBackButton,
  isLimitedEdition,
  nextButtonDisabled,
  nextText = 'Next',
  backText = 'Back',
  className = '',
  isButtonResponsive = false
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.buttons, className ? className : '')
}, onBackButton && /*#__PURE__*/React.createElement(Button, {
  dataButton: "Back",
  type: "defaultGrey",
  className: classnames(classes.button, isButtonResponsive ? classes.buttonResponsive : ''),
  onClick: onBackButton
}, backText), /*#__PURE__*/React.createElement(Button, {
  dataButton: "Next",
  type: "primary",
  disabled: nextButtonDisabled,
  className: classnames(classes.button, {
    [classes.primaryLE]: isLimitedEdition
  }, isButtonResponsive ? classes.buttonResponsive : ''),
  onClick: onNextButton
}, nextText));